export default __webpack_public_path__ + "static/media/top-5-factors-career-selection.abc6b7c7.jpg";